import { useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { style } from "./Style.js";

import { CSSTransition, TransitionGroup } from "react-transition-group";
import { BsFillPlayFill, BsX, BsFillSkipBackwardFill, BsFillClockFill } from "react-icons/bs";

import Markdown from "react-markdown";
import RehypeRaw from "rehype-raw";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import ListGroup from "react-bootstrap/ListGroup";

import SolutionTitle from "./SolutionTitle.js";
import DocumentTitle from "./DocumentTitle.js";

import ItemSelectionDroppable from "./ItemSelectionDroppable.js";

const mainButtonClassNames = "bg-primary ";
const disabledButtonClassNames = "opacity-25 ";
const closedButtonClassNames = "opacity-50 ";
const openedButtonClassNames = "";
const navigationButtonClassNames = "bg-secondary ";

const baseTextClassNames = "fs-5 text-end ";
const mainTextClassNames = "text-primary ";
const disabledTextClassNames = "opacity-25 ";
const closedTextClassNames = "opacity-50 ";
const openedTextClassNames = "fw-medium ";
const navigationTextClassNames = "text-secondary ";

export default function DialogueTextCard (props)
{
    const gData = useData();
    const gDispatch = useDispatch();
    
    // FUNCTIONS
    function nextDialogue () { gDispatch({ type: "nextDialogue" }); }
    function choiceDialogue (num, label, time) { gDispatch({ type: "choiceDialogue", num, label, time }); }    

    function closeDialogue ()
    {
	gDispatch({ type: "closeModal", modal: "dialogue" });
	if (gData.content.params.oneCharPerPlace)
	{
	    if (gData.content.params.itemGameplay) gDispatch({ type: "openModal", modal: "items" });
	    else gDispatch({ type: "openModal", modal: "map" });

	    if (gData.gameId === "ada" && gData.state.currentPlaceId === gData.content.chars["pierre"].placeId && gData.state.badges["fin"] !== undefined && gData.state.badges["fin"].state === "opened")
	    {
		gDispatch({ type: "endRealTime" });
		gDispatch({ type: "openModal", modal: "end" });
	    }
	}
    }

    function openInformation (informationId) { gDispatch({ type: "openInformation", informationId }); }
    function applyItems (itemIds, charId) { gDispatch({ type: "applyItems", itemIds, charId }); }
    function missItems (itemIds, charId) { gDispatch({ type: "missItems", itemIds, charId }); }
    
    function addToScore (value)
    {
	if (value === 0) return;
	else if (value > 0)
	{
	    gDispatch({ type: "alert", data: { variant: "success", title: "Bravo !", content: (<span>Vous gagnez {value}% de cybersécurité.</span>) }});
	}
	
	else {
	    gDispatch({ type: "alert", data: { variant: "danger", title: "Attention...", content: (<span>Vous perdez {-value}% de cybersécurité.</span>) }});
	    gDispatch({ type: "addToErrors", value: 1 });
	}

	gDispatch({ type: "addToScore", value });
    }

    function parseText (text)
    {
	let type = null;
	if (text.includes("<back>")) { type = "back"; text = text.replace("<back>", ""); }
	else if (text.includes("<origin>")) { type = "origin"; text = text.replace("<origin>", ""); }
	else if (text.includes("<end>")) { type = "end"; text = text.replace("<end>", ""); }
	else if (text.includes("<blue>")) { type = "blue"; text = text.replace("<blue>", ""); }
	else if (text.includes("<yellow>")) { type = "yellow"; text = text.replace("<yellow>", ""); }
	else if (text.includes("<red>")) { type = "red"; text = text.replace("<red>", ""); }
	
	let parsed = [ ...text.matchAll(/^([^{]*){([^}]*)}(\([^)]*\))?(.*)$/g) ];
	while (parsed.length > 0)
	{
	    let char = "";
	    if (parsed[0][3] === undefined) char = gData.content.chars[parsed[0][2].toLowerCase()];
	    else char = gData.content.chars[parsed[0][3].slice(1,-1)];
	    
	    //const charText = char === undefined ? parsed[0][2] : "<span style='color: " + char.color + "'>**" + parsed[0][2] + "**</span>";
	    //const charText = char === undefined ? parsed[0][2] : "<span style='background-color: " + char.color + "'>&nbsp;" + parsed[0][2] + "&nbsp;</span>";
	    //const charText = char === undefined ? parsed[0][2] : "<span style='background-color: " + char.color + "; text-decoration: solid underline overline " + char.color + " 3px; text-decoration-skip-ink: none;'>&nbsp;" + parsed[0][2] + "&nbsp;</span>";
	    
	    const charText = char === undefined ? parsed[0][2] : "<span style='text-decoration: solid underline " + char.color + " 4px; text-decoration-skip-ink: none;'>" + parsed[0][2] + "</span>";
	    
	    text = parsed[0][1] + charText + parsed[0][4];
	    parsed = [ ...text.matchAll(/^([^{]*){([^}]*)}(\([^)]*\))?(.*)$/g) ];
	}

	return { text, type };
    }


    // VARIABLES
    
    const dialogue = gData.state.currentDialogue;
    const char = dialogue === null || dialogue.charId === null ? null : gData.content.chars[dialogue.charId];

    // EVENTS
    useEffect(() => {
	if (gData.state.currentDialogue !== null)
	{
	    const dialogue = gData.state.currentDialogue;
	    dialogue.events.forEach((eventId) => {
		const eventContent = gData.content.themes[gData.state.currentThemeId].events[eventId];
		if (eventContent === undefined) return;

		eventContent.list.forEach((e) => {
		    switch (e.type)
		    {
			case "goToChar" :
			const charContent = gData.content.chars[e.charId];
			gDispatch({ type: "goToPlaceAndChar", placeId: charContent.placeId, charId: e.charId });
			break;

			case "goToPlace" :
			gDispatch({ type: "goToPlace", placeId: e.placeId });
			break;

			case "setVar" :
			gDispatch({ type: "setVar", var: e.var, value: e.value });
			break;

			case "setVars" :
			gDispatch({ type: "setVars", vars: e.vars, values: e.values });
			break;

			case "addToScore" :
			gDispatch({ type: "addToScore", value: e.value });

			if (e.value > 0) gDispatch({ type: "alert", data: { variant: "success", title: "Bravo !", content: (<span>Vous gagnez {e.value}% de cybersécurité.</span>) }});
			else if (e.value < 0)
			{
			    gDispatch({ type: "alert", data: { variant: "danger", title: "Attention...", content: (<span>Vous perdez {-e.value}% de cybersécurité.</span>) }});
			    gDispatch({ type: "addToErrors", value: 1 });
			}
			break;

			default:
		    }
		});
	    });
	}
    }, [gData.state.currentDialogue]);

    // TEXT
    let dialogueText = dialogue === null ? null : dialogue.text;
    let dialogueType = null;

    if (dialogueText !== null)
    {
	const result = parseText(dialogueText);
	dialogueText = result.text;
	dialogueType = result.type;
    }


    // SOLUTIONS, DOCUMENTS, INFORMATIONS, ITEMS

    const newSolutionIds = dialogue === null ? [] : dialogue.solutions.filter((solutionId) => ! gData.state.solutions[solutionId].found);
    
    /* const solutionItems = dialogue === null ? [] : dialogue.solutions.map((solutionId) => {
       if (gData.state.solutions[solutionId].found)
       {
       const solution = gData.content.solutions[solutionId];
       return (
       <Row key={solution.id}>
       <Col md={3}><span className="fs-6 fst-italic">Solution débloquée</span></Col>
       <Col md={9}><SolutionTitle solutionId={solution.id}/></Col>
       </Row>
       );
       }
     * }); */

    const newDocumentIds = dialogue === null ? [] : dialogue.documents.filter((documentId) => ! gData.state.documents[documentId].found);

    /* const newDocumentIds = [];    
     * const documentItems = dialogue === null ? [] : dialogue.documents.map((documentId) => {
       if (gData.state.documents[documentId].found)
       {
       const document = gData.content.documents[documentId];
       const typeStr = document.type === "advice" ? "Avis" : "Document";
       let documentTitle = document.title;
       if (document.type === "advice") documentTitle = "Avis de " + char.title + " sur " + gData.content.solutions[document.solutionId].title;
       return (
       <Row key={document.id}>
       <Col md={3}><span className="fs-6 fst-italic">{typeStr} débloqué</span></Col>
       <Col md={9}><DocumentTitle documentId={document.id}/></Col>
       </Row>
       );
       } else { newDocumentIds.push(documentId); }
     * }); */
    
    const informationItems = dialogue === null ? [] : dialogue.informations.map((informationId) => {
	const information = gData.content.documents[informationId];
	return (
	    <Row key={information.id} className="d-flex align-items-center">
		<Col md={3}><span className="fs-6 fst-italic">Information disponible</span></Col>
		<Col md={9}><Button onClick={() => openInformation(information.id)}>{information.title}</Button></Col>
	    </Row>
	);
    });

    const newItemIds = dialogue === null ? [] : dialogue.items.filter((itemId) => ! gData.state.items[itemId].found);

    /* const itemItems = dialogue === null ? [] : dialogue.items.map((itemId) => {
       if (gData.state.items[itemId].found) return (<></>);
       else newItemIds.push(itemId);
     * }); */

    // CHAR QUESTS
    let newCharQuests = {};
    if (dialogue !== null)
    {
	dialogue.openChars
		.filter((openChar) => gData.state.charQuests[openChar.id] === undefined)
		.forEach((openChar) => { newCharQuests[openChar.id] = { ...openChar, themeId: gData.state.currentThemeId, state: "opened" }; });

	dialogue.closeChars
		.filter((closeChar) => gData.state.charQuests[closeChar.id] === undefined || gData.state.charQuests[closeChar.id].state === "opened")
		.forEach((closeChar) => { newCharQuests[closeChar.id] = { ...closeChar, themeId: gData.state.currentThemeId, state: "closed" }; });
    }

    // CHOICE QUESTS
    let newChoiceQuests = {};
    if (dialogue !== null)
    {
	dialogue
	    .openChoices
	    .filter((openChoice) => gData.state.choiceQuests[openChoice.id] === undefined)
	    .forEach((openChoice) => { newChoiceQuests[openChoice.id] = { ...openChoice, themeId: gData.state.currentThemeId, state: "opened" }; });

	dialogue
	    .closeChoices
	    .filter((closeChoice) => gData.state.choiceQuests[closeChoice.id] === undefined || gData.state.choiceQuests[closeChoice.id].state === "opened")
	    .forEach((closeChoice) => { newChoiceQuests[closeChoice.id] = { ...closeChoice, themeId: gData.state.currentThemeId, state: "closed" }; });
    }

    // BADGES
    let newBadges = {}
    if (dialogue !== null)
    {
	dialogue
	    .badges
	    .filter((badge) => gData.state.badges[badge.id] === undefined)
	    .forEach((badge) => { newBadges[badge.id] = { ...badge, state: "opened" }; });
    }
    
    useEffect(() => {
	if (newSolutionIds.length === 0 && newDocumentIds.length === 0 && newItemIds.length === 0)
	{
	    if (Object.keys(newCharQuests).length > 0) gDispatch({ type: "addCharQuests", charQuests: newCharQuests });	
	    if (Object.keys(newChoiceQuests).length > 0) gDispatch({ type: "addChoiceQuests", choiceQuests: newChoiceQuests });	
	    if (Object.keys(newBadges).length > 0) gDispatch({ type: "addBadges", badges: newBadges });
	}
    }, [gDispatch]);

    // END
    const end = dialogue === null ? false : dialogue.end && dialogue.text === "";

    useEffect(() => { if (end) closeDialogue(); }, [end]);

    
    function applyDialogue () {
	if (newSolutionIds.length > 0) gDispatch({ type: "addSolutions", solutionIds: newSolutionIds });	
	if (newDocumentIds.length > 0) gDispatch({ type: "addDocuments", documentIds: newDocumentIds });
	if (newItemIds.length > 0) gDispatch({ type: "addItems", itemIds: newItemIds });
	if (Object.keys(newCharQuests).length > 0) gDispatch({ type: "addCharQuests", charQuests: newCharQuests });	
	if (Object.keys(newChoiceQuests).length > 0) gDispatch({ type: "addChoiceQuests", choiceQuests: newChoiceQuests });	
	if (Object.keys(newBadges).length > 0) gDispatch({ type: "addBadges", badges: newBadges });

	if (newSolutionIds.length > 0)
	{
	    const solutionTitles = newSolutionIds.map((solutionId) => (<SolutionTitle key={solutionId} solutionId={solutionId} simple={true}/>));
	    const alertContent = (<div className="d-flex flex-column gap-2">{solutionTitles}</div>);
	    gDispatch({ type: "alert", data: { variant: "light", title: (newSolutionIds.length === 1 ? "Nouvelle solution" : "Nouvelles solutions"), content: alertContent }});
	}
	
	if (newDocumentIds.length > 0)
	{
	    const documentTitles = newDocumentIds.map((documentId) => (<DocumentTitle key={documentId} documentId={documentId}/>));
	    const alertContent = (<div className="d-flex flex-column align-items-stretch gap-2">{documentTitles}</div>);
	    gDispatch({ type: "alert", data: { variant: "light", title: (newDocumentIds.length === 1 ? "Nouveau document" : "Nouveaux documents"), content: alertContent }});
	}

	newItemIds.forEach((itemId) => {
	    const item = gData.state.items[itemId];
	    const itemContent = gData.content.items[item.id];
	    //const alertContent = (<ItemTitle itemId={item.id}/>);
	    const alertContent = (
		<>
		    <p className="fs-5">{itemContent.title}</p>
		    <p>{itemContent.description}</p>
		</>
	    );

	    let alertTitle = "";
	    let alertVariant = "secondary";
	    
	    switch (itemContent.type)
	    {
		case "info" :   alertTitle = "Nouvelle information"; alertVariant = "warning"; break;
		case "bp" :     alertTitle = "Nouveau conseil";      alertVariant = "info";    break;
		case "indice" : alertTitle = "Nouvel indice";        alertVariant = "success"; break;
		default:
	    }
	    
	    gDispatch({ type: "alert", data: { variant: alertVariant, title: alertTitle, content: alertContent }});
	});
    }

    function applyItemSelection ()
    {
	if (props.itemStruct.type === "info")
	{
	    const itemId1 = props.itemStruct.selectionIds[0];
	    const itemContent1 = gData.content.items[itemId1];

	    const itemId2 = props.itemStruct.selectionIds[1];
	    const itemContent2 = gData.content.items[itemId2];

	    if (itemContent1.toCharIds.includes(props.itemStruct.charId) && itemContent2.toCharIds.includes(props.itemStruct.charId))
	    {
		if (! gData.state.items[itemId1].appliedToCharIds.includes(props.itemStruct.charId) && ! gData.state.items[itemId2].appliedToCharIds.includes(props.itemStruct.charId))
		{
		    applyItems([itemId1, itemId2], props.itemStruct.charId);
		    addToScore(gData.content.params.scoreInfo);
		}
		choiceDialogue(null, props.itemStruct.labelRight, 0);
	    }

	    else {
		addToScore(-1);
		missItems([itemId1, itemId2], props.itemStruct.charId);
		choiceDialogue(null, props.itemStruct.labelWrong, 0);
	    }
	}

	else if (props.itemStruct.type === "bp")
	{
	    const itemId = props.itemStruct.selectionIds[0];
	    const itemContent = gData.content.items[itemId];

	    if (itemContent.toCharIds.includes(props.itemStruct.charId))
	    {
		if (! gData.state.items[itemId].appliedToCharIds.includes(props.itemStruct.charId))
		{
		    applyItems([itemId], props.itemStruct.charId);
		    addToScore(gData.content.params.scoreBp);
		}
		choiceDialogue(null, props.itemStruct.labelRight, 0);
	    }

	    else {
		addToScore(-1);
		missItems([itemId], props.itemStruct.charId);
		choiceDialogue(null, props.itemStruct.labelWrong, 0);
	    }
	}

    }
    
    
    // BUTTONS
    let choiceButtons = [];
    let itemSelectionDroppables = [];
    let itemSelectionText = (<></>);
    const questionClassName = "question d-flex gap-3 justify-content-end align-items-center border-0 bg-transparent";

    if (dialogue !== null && char !== null)
    {
	if (newSolutionIds.length > 0 || newDocumentIds.length > 0 || newItemIds.length > 0)
	{
	    choiceButtons = (
		<ListGroup.Item action onClick={applyDialogue} className={questionClassName}>
		    <span className={baseTextClassNames + mainTextClassNames + openedTextClassNames}>Je prends note !</span>
		    <Badge className={mainButtonClassNames} onClick={() => {}}><BsFillPlayFill className="fs-4"/></Badge>
		</ListGroup.Item>
	    );
	}
	
	else if (dialogue.choices.length === 0 && dialogue.interfaces.length === 0)
	{
	    if (dialogue.end || dialogueType === "end")
		choiceButtons = (
		    <ListGroup.Item action onClick={closeDialogue} className={questionClassName}>
			<span className={baseTextClassNames + navigationTextClassNames + openedTextClassNames}></span>
			<Badge className={navigationButtonClassNames} onClick={() => {}}><BsX className="fs-4"/></Badge>
		    </ListGroup.Item>
		);
	    
	    else if (dialogueType === "origin")
		choiceButtons = (
		    <ListGroup.Item action onClick={nextDialogue} className={questionClassName}>
			<span className={baseTextClassNames + navigationTextClassNames + openedTextClassNames}></span>
			<Badge className={navigationButtonClassNames} onClick={() => {}}><BsFillSkipBackwardFill className="fs-4"/></Badge>
		    </ListGroup.Item>
		);
	    
	    else if (dialogueType === "back")
		choiceButtons = (
		    <ListGroup.Item action onClick={nextDialogue} className={questionClassName}>
			<span className={baseTextClassNames + navigationTextClassNames + openedTextClassNames}></span>
			<Badge className={navigationButtonClassNames} onClick={() => {}}><BsFillPlayFill className="fs-4" style={{ transform: "scaleX(-1)" }}/></Badge>
		    </ListGroup.Item>
		);

  	    else {
		let buttonClassNames = navigationButtonClassNames;
		if (dialogueType === "red") buttonClassNames = "bg-danger ";
		else if (dialogueType === "yellow") buttonClassNames = "bg-warning text-white ";
		else if (dialogueType === "blue") buttonClassNames = "bg-info text-white ";
		
		choiceButtons = (
		    <ListGroup.Item action onClick={nextDialogue} className={questionClassName}>
			<span className={baseTextClassNames + navigationTextClassNames + openedTextClassNames}></span>
			<Badge className={buttonClassNames} onClick={() => {}}><BsFillPlayFill className="fs-4"/></Badge>
		    </ListGroup.Item>
		);
	    }
	}

	else {
	    //let buttonWidth = "50px";
	    //if (gData.content.params.timeGameplay) { buttonWidth = "130px"; }

  	    choiceButtons = dialogue
		.choices
		.sort((choice1, choice2) => {
		    const choiceType1 = parseText(choice1.text).type;
		    const choiceType2 = parseText(choice2.text).type;
		    const opened1 = choice1.opened || choiceType1 === "end";
		    const opened2 = choice2.opened || choiceType2 === "end";
		    if (opened1 && opened2) return 0;
		    else if (opened1) return +1;
		    else if (opened2) return -1;
		    
		    if (gData.content.params.choiceQuests)
		    {
			const quest1 = gData.state.choiceQuests[choice1.label] || newChoiceQuests[choice1.label];
			const quest2 = gData.state.choiceQuests[choice2.label] || newChoiceQuests[choice2.label];
			if (quest1 === undefined && quest2 === undefined) return 0;
			else if (quest2 === undefined) return -1
			else if (quest1 === undefined) return +1
			else return quest1.time - quest2.time;
		    }

		    return 0;					
		})
		.map(choice => {

		    const result = parseText(choice.text);
		    let choiceText = result.text;
		    let choiceType = result.type;

		    let hidden = !choice.opened && choiceType !== "end" && gData.content.params.choiceQuests && gData.state.choiceQuests[choice.label] === undefined && newChoiceQuests[choice.label] === undefined;
		    let started = gData.state.themes[gData.state.currentThemeId].choiceNums.includes(choice.num);
		    let closed = !choice.opened && ((gData.state.choiceQuests[choice.label] !== undefined && gData.state.choiceQuests[choice.label].state === "closed") || (newChoiceQuests[choice.label] !== undefined && newChoiceQuests[choice.label].state === "closed"));		

		    if (choiceType === "blue")
		    {
			const allBp = Object.values(gData.content.items)
					    .filter((item) => item.type === "bp" && item.themeId === gData.state.currentThemeId && item.toCharIds.includes(char.id));
			const doneBp = allBp.filter((item) => gData.state.items[item.id].appliedToCharIds.includes(char.id));
			closed = doneBp.length === allBp.length;

			choiceText += " (" + doneBp.length + "/" + allBp.length + ")";
		    }

		    if (hidden) return (<ListGroup.Item key={choice.num} className="d-none"/>);

		    let buttonClassNames = mainButtonClassNames;
		    let textClassNames = mainTextClassNames;

		    if (choiceType === "back" || choiceType === "origin" || choiceType === "end") { buttonClassNames = navigationButtonClassNames; textClassNames = navigationTextClassNames; }
		    else if (choiceType === "red") { buttonClassNames = "bg-danger "; textClassNames = "text-danger " }
		    else if (choiceType === "blue") { buttonClassNames = "bg-danger text-white "; textClassNames = "text-danger " }
		    else if (choiceType === "yellow") { buttonClassNames = "bg-danger text-white "; textClassNames = "text-danger " }
		    
		    if (closed) { buttonClassNames = buttonClassNames + closedButtonClassNames; textClassNames = textClassNames + closedTextClassNames; }
		    else { buttonClassNames = buttonClassNames + openedButtonClassNames; textClassNames = textClassNames + openedTextClassNames; }

		    let time = null;
		    let buttonTitle = (<BsFillPlayFill className="fs-4"/>);
		    if (choiceType === "end") buttonTitle = (<BsX className="fs-4"/>);
		    /* if (choiceType === "end") buttonTitle = gData.content.params.timeGameplay ? (<span>Quitter</span>) : (<BsX className="fs-4"/>); */
		    else if (choiceType === "origin") buttonTitle = (<BsFillSkipBackwardFill className="fs-4"/>);
		    else if (choiceType === "back") buttonTitle = (<BsFillPlayFill className="fs-4" style={{ transform: "scaleX(-1)" }}/>);

		    if (gData.content.params.timeGameplay && choiceType !== "end")
		    {
			if (started) time = 0;
			else if (choice.time !== null) time = choice.time;
			else time = gData.content.params.defaultTime;
			
  			buttonTitle = (<BsFillPlayFill className="fs-4"/>);
  			//buttonTitle = (<span>Gratuit</span>);
			
			if (time !== 0) buttonTitle = (<BsFillClockFill className="fs-4"/>);
			//if (time !== 0) buttonTitle = (<span>🕑 <span className={(started ? " text-decoration-line-through" : "")}>+{time} min</span></span>);
		    }
		    
		    //let disabled = time !== 0 && ! choice.closed && gData.state.timeOut && choiceType !== "end";
		    const free = ! gData.content.params.timeGameplay || choiceType === "end" || time === 0;

		    let text = (<span className={baseTextClassNames + textClassNames}><Markdown components={{ p: "span" }} rehypePlugins={[ RehypeRaw ]}>{choiceText}</Markdown></span>);
		    
		    let button = (
			<Badge className={buttonClassNames + (free ? "bg-primary" : "bg-danger")}>
			    {buttonTitle}
			</Badge>
		    );
		    
  		    let group = (<></>);

		    if (free)
		    {
			group = (
			    <ListGroup.Item key={choice.num} action onClick={() => choiceDialogue(choice.num, choice.label, time)} className={questionClassName}>
				{text}
				{button}
			    </ListGroup.Item>
			);
		    }
		    
		    else {
			const popover = (
			    <Popover className={style.popover.className}>
				<Popover.Body className={style.popover.body.className}>
				    {time} minute{time > 1 ? "s" : ""}
				</Popover.Body>
			    </Popover>
			);
				
			group = (
			    <OverlayTrigger placement="top" overlay={popover}>
				{({ ref, ...triggerHandler }) => (
				    <ListGroup.Item key={choice.num} action onClick={() => choiceDialogue(choice.num, choice.label, time)} className={questionClassName} {...triggerHandler}>
					{text}
					<div ref={ref}>{button}</div>
				    </ListGroup.Item>
				)}
			    </OverlayTrigger>
			);
		    }		

		    return group;
  		});

	    if (dialogue.interfaces.length > 0 && props.itemStruct !== null)
	    {
		let validateButtonTitle = "";
		let skipButtonTitle = "";
		if (props.itemStruct.type === "info")
		{
		    validateButtonTitle = "Voici mon raisonnement !";
		    skipButtonTitle = "Je ne sais pas...";
		    itemSelectionDroppables.push(<ItemSelectionDroppable key={0} num={0} itemStruct={props.itemStruct}/>);
		    itemSelectionDroppables.push(<ItemSelectionDroppable key={1} num={1} itemStruct={props.itemStruct}/>);

		    const charName = gData.content.chars[props.itemStruct.charId].firstName;
		    itemSelectionText = (<span>Glissez et déposez les deux informations qui vous semblent aider {charName} à résoudre son problème.</span>);
		}

		else if (props.itemStruct.type === "bp")
		{
		    validateButtonTitle = "Voici mon conseil !";
		    skipButtonTitle = "Je ne sais pas...";
		    itemSelectionDroppables.push(<ItemSelectionDroppable key={0} num={0} itemStruct={props.itemStruct}/>);

		    const charName = gData.content.chars[props.itemStruct.charId].firstName;
		    itemSelectionText = (<span>Glissez et déposez le conseil que vous souhaitez donner à {charName}.</span>);
		}

		const disabled = props.itemStruct === null ||
				 (props.itemStruct.type === "info" && (props.itemStruct.selectionIds[0] === null || props.itemStruct.selectionIds[1] === null)) ||
				 (props.itemStruct.type === "bp" && props.itemStruct.selectionIds[0] === null);
		
		choiceButtons.push(
		    <ListGroup.Item key={"validate"} action disabled={disabled} onClick={() => applyItemSelection()} className={questionClassName}>
			<span className={baseTextClassNames + mainTextClassNames + openedTextClassNames + (disabled ? disabledTextClassNames : "")}>{validateButtonTitle}</span>
			<Badge className={mainButtonClassNames + openedButtonClassNames + (disabled ? disabledButtonClassNames : "")}>
			    <BsFillPlayFill className="fs-4"/>
			</Badge>
		    </ListGroup.Item>
		);

		choiceButtons.push(
		    <ListGroup.Item key={"skip"} action onClick={() => { choiceDialogue(null, props.itemStruct.labelSkip, 0); }} className={questionClassName}>
			<span className={baseTextClassNames + navigationTextClassNames + openedTextClassNames}>{skipButtonTitle}</span>
			<Badge className={navigationButtonClassNames + openedButtonClassNames}>
			    <BsFillSkipBackwardFill className="fs-4"/>
			</Badge>
		    </ListGroup.Item>
		);
	    }
	}

	//if (choiceButtons.length > 8 && false) choiceButtons = (<ListGroup className="d-flex flex-row flex-wrap justify-content-end">{choiceButtons}</ListGroup>);
	//else
	choiceButtons = (<ListGroup variant="flush" className="w-100">{choiceButtons}</ListGroup>);
    }
    
    // RENDER
    //const charId = gData.state.currentDialogue !== null && gData.state.showModals.dialogue ? gData.state.currentDialogue.charId : null;
    let placeId = gData.state.currentDialogue !== null && gData.state.showModals.dialogue ? gData.state.currentPlaceId : null;
    if (placeId === "hopital") placeId = "lycee";
    
    return (
	<TransitionGroup>
	    <CSSTransition timeout={1000} key={placeId} classNames="translate-right" appear>
		<>
		    {(dialogue !== null && char !== null && gData.state.showModals.dialogue) && (
			<div className="position-absolute end-0 mx-4 vh-100 d-flex flex-column align-items-center">
			    <Card className="shadow border-2 z-1 user-select-none" style={{ ...style.modal.dialogue.style, borderColor: char.color }}>
				<Card.Header style={{ backgroundColor: char.color, borderColor: char.color }} className="d-flex align-items-center justify-content-between">
				    <div className="fs-4">{char.firstName} <span className="text-uppercase">{char.lastName}</span></div>
				    <div className="fs-4 fw-medium">{char.title}</div>
				</Card.Header>
				<Card.Body className="overflow-auto">
				    <div className="fs-5 m-1"><Markdown rehypePlugins={[ RehypeRaw ]}>{dialogueText}</Markdown></div>
				    <div className="d-flex flex-column gap-2">
					{informationItems}
					{/* {solutionItems} {documentItems} */}
				    </div>
				</Card.Body>
			    </Card>
			    <Card className="shadow border-2 border-secondary user-select-none" style={style.modal.questions.style}>
				<Card.Footer className="h-100 py-3 overflow-auto">
				    {(dialogue.interfaces.length > 0 && props.itemStruct !== null) && (
					<>
					    <div className="text-center my-1 fst-italic">{itemSelectionText}</div>
					    <div className="d-flex justify-content-center gap-2 mb-2">
						{itemSelectionDroppables}
					    </div>
					</>
				    )}
				    <div className="d-flex gap-2 justify-content-end flex-wrap">
					{choiceButtons}
				    </div>
				</Card.Footer>
			    </Card>
			</div>
		    )}
		</>
	    </CSSTransition>
	</TransitionGroup>
    );
}


